"use strict";

var _classCallCheck = require("/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/classCallCheck.js");
var _createClass = require("/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/createClass.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SuspenseResourceStorage = void 0;
var suspense_resource_1 = require("./suspense-resource");
var SuspenseResourceStorage = /*#__PURE__*/function () {
  function SuspenseResourceStorage() {
    var _this = this;
    _classCallCheck(this, SuspenseResourceStorage);
    this.map = new Map();
    this.getOrAdd = function (name, path, factory) {
      var _a;
      return (_a = _this.map.get(_this.getKey(name, path))) !== null && _a !== void 0 ? _a : _this.create(name, path, factory);
    };
    this.create = function (name, path, factory) {
      var resource = new suspense_resource_1.SuspenseResource(factory());
      _this.map.set(_this.getKey(name, path), resource);
      return resource;
    };
    this.delete = function (name, path) {
      _this.map.delete(_this.getKey(name, path));
    };
  }
  _createClass(SuspenseResourceStorage, [{
    key: "getKey",
    value: function getKey(name, path) {
      return "".concat(name, "_").concat(path);
    }
  }]);
  return SuspenseResourceStorage;
}();
exports.SuspenseResourceStorage = SuspenseResourceStorage;